// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OfferEquipment_wrapper__3SwR6","h":"OfferEquipment_h__3hBpX","opts":"OfferEquipment_opts__1RN6l","opt":"OfferEquipment_opt__Oh6MT","more":"OfferEquipment_more__1NYPd"};